var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutdated = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 193,
    fill: "none",
    viewBox: "0 0 165 193",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M58.875 74.32a.367.367 0 0 1 .503-.113.368.368 0 0 1 .114.504c-.044.064-14.52 22.58-3.086 35.705.13.151.119.384-.033.515a.362.362 0 0 1-.514-.033c-11.796-13.536 2.972-36.507 3.016-36.578zM101.091 71.183a.368.368 0 0 1 .113-.504.368.368 0 0 1 .504.114c.022.038 8.294 12.886-.428 22.754a.366.366 0 0 1-.514.032.367.367 0 0 1-.032-.514c8.358-9.451.378-21.844.357-21.882z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M61.213 59.115l-6.096 6.709s2.918 5.175 2.631 11.954c-.292 6.784-23.138 44.381 19.073 44.186 42.205-.196 18.726-21.99 18.726-21.99s13.924-4.514 6.892-24.694c-7.033-20.17-41.226-16.165-41.226-16.165z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#01020E",
    fillRule: "evenodd",
    d: "M95.932 100.358c-.244-.243-.39-.379-.39-.379s.498-.162 1.261-.564a37.98 37.98 0 0 0 3.606-4.768c5.755-8.958-.368-21.27-.368-21.27l-3.26-.975s-6.485-2.325-8.228-2.904c-1.743-.58-21.877.677-27.589 11.434-5.711 10.756.65 26.346.65 26.346s23.745-.769 25.098-.861c1.012-.071 4.916-1.593 9.22-6.059z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4AD85",
    fillRule: "evenodd",
    d: "M107.284 106.227c6.784 2.964 7.661 9.169 8.543 16.078.78 6.123 1.029 15.368-.585 29.403C113.629 165.748 88 133.186 88 133.186l19.284-26.959zM67.407 106.043l-6.583-3.371s-6.957 1.734-10.514 6.21c-3.557 4.476-14.336 42.739-14.742 47.416-.406 4.682 2.762 22.51 8.554 22.51 5.793 0 8.678-38.984 8.678-38.984l4.732-14.609 9.875-19.172z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F55",
    fillRule: "evenodd",
    d: "M84.85 97.633s17.492 6.237 22.429 8.589c-.011.01-.942.986-2.009 6.356-1.066 5.392 0 13.227-1.115 20.96-.807 5.587-4.585 33.858-6.62 49.117l-43.116-3.479a104.01 104.01 0 0 0-.081-2.422c3.54 2.758 6.935 2.883 4.834-5.18-3.66-14.041-2.95-38.464-1.727-45.79 1.218-7.327 3.038-15.038 1.31-22.467 1.159-1.046 26.095-5.684 26.095-5.684z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B23539",
    fillRule: "evenodd",
    d: "M98.817 102.781l.363.135c-.78 3.138-1.819 6.817-3.27 8.985-1.31 1.956-2.842 3.755-5.062 5.045-2.22 1.289-5.126 2.059-9.181 1.961-3.535-.092-6.372-1.392-8.57-3.246-2.864-2.411-4.634-5.744-5.43-8.535-1.115-3.901-2.171-5.202-2.528-5.554l.427-.092c.498.585 1.478 2.081 2.469 5.544.78 2.731 2.512 5.993 5.31 8.345 2.14 1.799 4.9 3.067 8.338 3.153 3.974.103 6.816-.65 8.976-1.907 2.16-1.252 3.654-3.013 4.937-4.926 1.419-2.129 2.453-5.793 3.221-8.908zm7.185 2.866c.108.049.216.092.319.141-.839 1.49-2.025 4.628-3.118 11.179-1.305 7.858.189 11.402 1.337 12.892-.011.179-.027.357-.038.536-1.229-1.398-3.086-5.001-1.673-13.493 1.072-6.437 2.279-9.656 3.173-11.255zm-48.849 22.31c.027-.249.055-.483.081-.71.986-1.935 4.727-10.453 2.594-24.364.113-.037.238-.07.373-.108 2.453 15.905-2.734 24.878-2.858 25.084a.133.133 0 0 1-.044.054.19.19 0 0 1-.146.044z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4AD85",
    fillRule: "evenodd",
    d: "M83.496 78.905h.13c3.795-.044 6.962 3.029 6.984 6.833l.086 14.019c2.54.926 5.577 2.053 8.424 3.143-4.477 9.672-9.755 16.067-18.195 14.235-11.559-2.509-11.147-12.219-14.666-15.801a538.27 538.27 0 0 1 10.492-2.146L76.669 85.9c-.021-3.804 3.027-6.953 6.827-6.996zM99.11 65.629c.135 0 .27.005.4.016h.006a5.404 5.404 0 0 1 .411 10.73 5.4 5.4 0 0 1-4.731-9.056c.076 1.599.584 3.523 2.625 3.452l-.47-3.078c-.185-1.257.898-1.983 1.759-2.064zM60.553 71.72c-.13.037-.26.075-.384.119h-.006a5.403 5.403 0 0 0-3.562 5.706 5.398 5.398 0 0 0 5.971 4.758 5.401 5.401 0 0 0 4.754-5.977 5.372 5.372 0 0 0-2.556-4c.347 1.561.358 3.555-1.635 4.016l-.352-3.094c-.14-1.258-1.38-1.68-2.23-1.529z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4AD85",
    fillRule: "evenodd",
    d: "M77.216 41.915c10.075-1.344 19.414 5.81 20.757 15.894l2.214 16.674c1.342 10.084-5.804 19.432-15.879 20.77-10.07 1.344-19.408-5.808-20.75-15.893l-2.22-16.674C60 52.6 67.147 43.254 77.216 41.916z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#01020E",
    fillRule: "evenodd",
    d: "M71.023 68.994a.694.694 0 0 0-.774.606.694.694 0 0 0 .6.775c.629.087 1.37.05 1.988-.054 1.358-.227 2.587-.834 3.475-1.913a.695.695 0 0 0-.092-.975.7.7 0 0 0-.98.092c-1.007 1.225-2.69 1.626-4.217 1.469z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M101.659 110.004s.704-.103.867.45c.157.553-2.182 3.528-2.334 3.631-.151.103-4.791-.483-4.791-.483s-.244-.227-.195-.406c.054-.179.222-.331.222-.331l6.231-2.861z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#01020E",
    fillRule: "evenodd",
    d: "M94.161 63.602c-1.516-.277-3.216-.027-4.33 1.127a.692.692 0 1 1-.997-.965c.97-1.002 2.247-1.506 3.617-1.62.622-.054 1.37-.027 1.986.108a.696.696 0 0 1 .542.819.693.693 0 0 1-.818.53z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M65.923 71.037l.314 2.362c.152 1.138-2.03 4.184-2.901 4.297l-.553-4.15s-.622-1.854-2.972-1.545c-8.31-7.337-9.111-20.63-2.322-28.482 6.789-7.852 23.257-10.49 26.273-9.91 3.015.579 6.637 5.082 6.637 5.082s2.16-2.514 4.58-1.68c2.425.835 11.943 14.176 12.419 17.764.476 3.587-5.517 11.623-5.517 11.623-2.35.314-2.463 2.265-2.463 2.265l.341 2.58c-.871.113-1.516-.987-1.667-2.125l-.314-2.362C90.112 64.5 85.954 55.132 85.954 55.132s-7.99 16.062-20.03 15.905z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#01020E",
    fillRule: "evenodd",
    d: "M65.924 71.037l.313 2.362c.152 1.138-2.03 4.184-2.901 4.297l-.553-4.15s-.622-1.854-2.972-1.545c-3.253-2.872-5.354-6.654-6.301-10.67.01.006 14.238 9.9 31.757-8.507 0 0 8.012 12.512 19.738 8.784-1.494 2.6-3.123 4.785-3.123 4.785-2.35.314-2.464 2.265-2.464 2.265l.341 2.58c-.871.113-1.516-.987-1.667-2.125l-.314-2.363c-7.666-2.254-11.824-11.623-11.824-11.623s-7.99 16.067-20.03 15.91z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4AD85",
    fillRule: "evenodd",
    d: "M101.226 95.763l1.197.325s.704-6.264.698-6.87c-.005-.608-.314-1.48-.779-2.504-.461-1.025-2.161-4.888-2.253-5.013-.092-.125-1.185.83-.692 2.525.492 1.696 1.331 3.989 1.326 4.476-.006.493-1.126 4.829-1.126 4.829l1.629 2.232z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4AD85",
    d: "M102.428 95.817c0-.574-.195-1.593-1.396-2.324-1.202-.732-4.039-2.98-4.645-3.24-.607-.266-1.3-.147-2.02.313-.72.461-2.988 2.022-3.47 2.52-.476.499-1.667 3.56-1.819 3.886-.146.32 1.056.612 2.009-.114 0 0-.499 1.008-.66 1.349-.163.341-.385 2.932-.402 3.457-.021.526 1.43.266 1.922-.943 0 0-.08.873-.08 1.138 0 .271.828.168.828.168s.958 5.197 1.169 5.847c.216.651 8.456 30.319 8.456 30.319l11.927-.721s-13.01-29.121-13.096-29.549c-.72-3.668 1.294-9.022 1.277-12.106z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M39.363 184.01h86.447c1.326 0 2.414-1.17 2.414-2.601s-1.088-2.601-2.414-2.601H39.363c-1.326 0-2.414 1.17-2.414 2.601s1.088 2.601 2.414 2.601z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M127.38 128.862H37.799c-1.332 0-2.258 1.089-2.057 2.422l6.848 45.519c.2 1.333 1.456 2.422 2.788 2.422h74.428c1.332 0 2.588-1.089 2.788-2.422l6.849-45.519c.195-1.333-.731-2.422-2.063-2.422z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M82.587 167.574c5.246 0 9.522-3.571 9.522-7.954 0-4.379-4.276-7.955-9.522-7.955s-9.523 3.571-9.523 7.955c.005 4.383 4.282 7.954 9.523 7.954z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M82.587 153.577c2.663 0 4.991 1.203 6.247 2.992l-11.07 7.554c-1.479-1.106-2.41-2.715-2.41-4.504 0-3.338 3.237-6.042 7.233-6.042zm5.88 9.57l-3.325-1.831-5.544 3.815a8.41 8.41 0 0 0 2.989.541c2.425-.005 4.569-.997 5.88-2.525z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#01020E",
    fillRule: "evenodd",
    d: "M92.223 68.609a1.55 1.55 0 0 0-1.283 1.767l.314 1.988c.135.84.931 1.42 1.77 1.284a1.552 1.552 0 0 0 1.283-1.771l-.314-1.99a1.555 1.555 0 0 0-1.77-1.278zM73.714 71.416a1.552 1.552 0 0 0-1.283 1.772l.314 1.989c.135.84.93 1.42 1.77 1.284a1.552 1.552 0 0 0 1.283-1.772l-.314-1.989a1.555 1.555 0 0 0-1.77-1.284zM90.599 82.324c.244.2.292.547.108.775-.184.228-.525.25-.763.049-.005-.006-1.852-1.615-5.143 1.414-.211.195-.558.168-.774-.06-.217-.232-.217-.58 0-.774 3.968-3.663 6.561-1.41 6.572-1.404z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F1630",
    fillRule: "evenodd",
    d: "M102.103 110.112s.238.027.276.336c.038.304-1.808 2.704-6.962 2.883 0 0-.124-.038-.14-.119-.022-.081.064-.168.064-.168l-.027-.098s-.184.136-.184.293c0 .157.764 3.349.915 4.151.152.802 1.722.618 3.048.293 1.327-.32 4.488-1.431 5.317-3.143 0 0 .102-.434-.028-.802-.129-.369-1.727-3.338-1.808-3.517-.081-.179-.335-.271-.514-.233l.043.124z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000618",
    fillRule: "evenodd",
    d: "M11.104 186.476h142.798a3.27 3.27 0 0 1 3.259 3.262 3.271 3.271 0 0 1-3.259 3.262H11.104a3.271 3.271 0 0 1-3.26-3.262 3.264 3.264 0 0 1 3.26-3.262z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE865E",
    fillRule: "evenodd",
    d: "M4.158 181.409h156.684a4.172 4.172 0 0 1 4.158 4.162 4.17 4.17 0 0 1-4.158 4.161H4.158A4.171 4.171 0 0 1 0 185.571c0-2.287 1.873-4.162 4.158-4.162z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#F55",
    fillRule: "evenodd",
    d: "M8.667 83.007H35.77c1.97 0 3.578 1.61 3.578 3.582v25.268a.382.382 0 0 1-.249.369.381.381 0 0 1-.433-.087l-6.096-6.107H8.667a3.588 3.588 0 0 1-3.578-3.582V86.583a3.593 3.593 0 0 1 3.578-3.576zM149.999 44.874h-28.195a3.737 3.737 0 0 0-3.725 3.728V74.89c0 .174.098.32.255.385s.33.033.454-.092l6.345-6.351h24.866a3.736 3.736 0 0 0 3.724-3.728v-16.5a3.74 3.74 0 0 0-3.724-3.729zM29.218 0h28.195a3.737 3.737 0 0 1 3.724 3.728v26.287c0 .174-.097.32-.254.385a.41.41 0 0 1-.455-.092l-6.345-6.346H29.218a3.737 3.737 0 0 1-3.725-3.728V3.728A3.737 3.737 0 0 1 29.218 0z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#63A9BA",
    fillRule: "evenodd",
    d: "M18.991 133.63c-4.336-4.422-7.563 1.192-7.113 6.828.427 5.343 5.03 23.675 4.174 31.386h1.76c4.314-9.889 6.729-32.556 1.18-38.214z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#80B9C9",
    fillRule: "evenodd",
    d: "M17.167 171.844c4.195-15.584-1.115-37.135-1.132-37.206a.25.25 0 0 0-.303-.184.25.25 0 0 0-.184.303c.016.071 5.333 21.644 1.11 37.087h.509z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#63A9BA",
    fillRule: "evenodd",
    d: "M8.294 143.368c-4.57-2.422-5.723 2.867-3.941 7.24 1.478 3.625 7.996 14.349 10.464 21.236h2.323c.195-9.521-3.454-25.615-8.846-28.476z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8C1",
    fillRule: "evenodd",
    d: "M16.29 171.844c-1.51-12.875-10.07-26.872-10.097-26.926a.21.21 0 0 0-.287-.071.212.212 0 0 0-.07.288c.033.048 8.532 13.959 10.043 26.709h.411z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A7F80",
    fillRule: "evenodd",
    d: "M27.605 149.481c4.428-1.935 5.132 3.072 3.161 7.023-1.331 2.671-6.128 9.521-9.36 15.34h-3.687c1.262-8.811 5.306-20.364 9.886-22.363z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#51A5A5",
    fillRule: "evenodd",
    d: "M19.035 171.845c3.145-10.676 10.383-20.733 10.416-20.771a.191.191 0 0 1 .27-.044.193.193 0 0 1 .044.271c-.027.038-7.195 9.993-10.33 20.544h-.4z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F365C",
    fillRule: "evenodd",
    d: "M10.005 167.688h15.31c.46 0 .833.374.833.835v3.782a.835.835 0 0 1-.833.835h-15.31a.835.835 0 0 1-.834-.835v-3.782c0-.461.373-.835.834-.835z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F365C",
    fillRule: "evenodd",
    d: "M12.63 170.766H22.69l2.625 2.374-2.143 8.269H12.149l-2.145-8.269 2.626-2.374z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#121C39",
    fillRule: "evenodd",
    d: "M25.314 173.14l-.438 1.696H10.443l-.439-1.696h15.31z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.817 8.123l-2.604 2.6V8.447a.652.652 0 0 0-.65-.65H41.54l7.277 7.265v-6.94zm-11.54-2.925l-.827.826 1.777 1.774h-.475a.652.652 0 0 0-.651.65v6.498c0 .357.293.65.65.65h7.811a.631.631 0 0 0 .352-.117l2.076 2.066.827-.825-11.54-11.522z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M128.876 62.57l15.621-11.779"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M141.938 50.763h-11.182a1 1 0 0 0-1 1v8.352l12.182-9.352zm-10.882 10.875h11.415a1 1 0 0 0 1-1v-8.53l-12.415 9.53z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M137.633 61.785v.285h-1.893v-.571h1.893v.285z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.541 93.867h-1.229a3.65 3.65 0 0 1-.31 1.472l.889.883c.405-.704.65-1.5.65-2.355zm-2.907.122c0-.044.015-.08.015-.123v-4.309a2.16 2.16 0 0 0-2.17-2.155c-1.2 0-2.17.963-2.17 2.155v.13l4.325 4.302zM15.89 88.12l-.919.912 4.347 4.316v.517c0 1.193.962 2.155 2.162 2.155.16 0 .318-.021.47-.057l1.2 1.192a4 4 0 0 1-1.67.373c-1.996 0-3.833-1.508-3.833-3.662h-1.23c0 2.449 1.968 4.474 4.34 4.826v2.356h1.446v-2.356a5.095 5.095 0 0 0 1.837-.646l3.03 3.002.919-.912-12.1-12.016z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.148 3.899h15.621v15.596H35.148z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutdated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outdated.c4caaa45fe2222ec4c8ed47f3b30fd94.svg";